import { FC, useMemo } from 'react'
import Select from 'components/base/forms/Select'
import { useGetGroupsQuery } from 'common/services/useGroup'

type GroupSelectType = {
  className?: string
  disabled?: boolean
  value: number[]
  isMulti?: boolean
  showID?: boolean
  onChange: (v: { value: number; label: string }[]) => void
  excludeGroups?: number[]
  label?: string
  defaultValue?: number
}

const GroupSelect: FC<GroupSelectType> = ({
  className,
  defaultValue,
  disabled,
  excludeGroups,
  isMulti,
  label,
  onChange,
  showID,
  value,
}) => {
  const { data } = useGetGroupsQuery({})

  const options = useMemo(
    () =>
      (data?.results || []).map((v) => ({
        label: `${v.name}`,
        value: v.id,
      })),
    [data],
  )

  const values = options?.filter((b) =>
    typeof value !== 'number' ? value?.includes(b.value) : value === b.value,
  )

  return (
    <div className={className}>
      {label && <label className='fw-semibold fs-lg mb-2'>{label}</label>}
      <div className='d-flex gap-4'>
        {data?.results?.length === 0 ? (
          <div className='text-center'>
            You have no groups, you can set these up within Team settings.
          </div>
        ) : (
          <Select
            isDisabled={disabled}
            className={'w-100'}
            isMulti={isMulti}
            value={values}
            onChange={(v: any) => {
              onChange(v)
            }}
            options={(defaultValue
              ? options.filter((b) => b.value !== defaultValue)
              : options
            ).filter((v) => {
              if (excludeGroups) {
                return !excludeGroups.includes(v.value)
              }
              return true
            })}
            getOptionLabel={
              (showID
                ? (option: { value: string; label: string }) => (
                    <>
                      <div className='d-flex gap-1 align-items-center'>
                        {option.label}
                      </div>
                    </>
                  )
                : undefined) as any
            }
          />
        )}
      </div>
    </div>
  )
}

export default GroupSelect
